import ActionHelper from "../helpers/ActionHelper";

export const getCollectiveLabourAgreements = () =>
  ActionHelper.requestServer("GET", "/cla");



// WEBPACK FOOTER //
// ./src/actions/claActions.js